export enum PromotionSegmentationType {
    ALL_STUDENTS = 'ALL_STUDENTS',
    COURSE_ENROLLMENT = 'COURSE_ENROLLMENT',
    SPECIFIC_STUDENTS = 'SPECIFIC_STUDENTS'
}